"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIER_HIERARCHY = exports.MODEL_TIERS = void 0;
exports.getAccessibleTiers = getAccessibleTiers;
exports.MODEL_TIERS = {
    1: { name: 'Standard', description: 'Basic AI models for everyday tasks' },
    2: { name: 'Standard', description: 'Enhanced models with greater capability' },
    3: { name: 'Premium', description: 'Top-tier models for complex reasoning' },
};
exports.TIER_HIERARCHY = [1, 2, 3];
function getAccessibleTiers(maxTier) {
    return exports.TIER_HIERARCHY.filter((t) => t <= maxTier);
}
//# sourceMappingURL=model-tiers.js.map